<template>
  <div>
    <div
        v-if="detail_loader"
        style="position:absolute; top:0; right:0; bottom:0; left:0; padding-top: 25%;background-color:rgba(255,255,255,0.31)"
    >
      <div class="text-xs-center">
        <v-progress-circular
            :size="70"
            :width="7"
            indeterminate
            color="#ff9233"
            class="text-xs-center my-5"
            large
        ></v-progress-circular>
      </div>
    </div>
    <v-container fluid grid-list-md class="padding_10" v-else>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12 class="text-xs-right" mt-3>
          <v-card><br/>
            <v-flex xs12 sm12 lg12 md12 class="text-xs-right" mt-1 style="display: flex; justify-content: flex-end; flex-wrap: wrap;">
                <v-btn
                    slot="activator"
                    color="rgb(248 71 6)"
                    class="white--text yatri_button"
                    @click="backtonotification()"
                >
                  <v-icon color="#bbbbc6" class="white--text mr-2"
                  >arrow_back
                  </v-icon
                  >
                  back
                </v-btn>
                <v-btn
                    slot="activator"
                    v-if="notification_detail.status == 'Draft'"
                    @click="deleteNotification(notification_detail.id)"
                    color="rgb(248 71 6)"
                    class="white--text yatri_button"
                >
                  <v-icon color="#bbbbc6" class="white--text mr-2"
                  >delete
                  </v-icon
                  >
                  Delete
                </v-btn>
                <v-btn
                    slot="activator"
                    v-if="notification_detail.status == 'Draft'"
                    @click="updateStaus(notification_detail.id,notification_detail.schedule_at)"
                    color="rgb(248 71 6)"
                    class="white--text yatri_button"
                >
                  <v-icon color="#bbbbc6" class="white--text mr-2"
                  >publish
                  </v-icon
                  >
                  Publish
                </v-btn>
                <v-btn
                    slot="activator"
                    @click="getNotificationId(notification_detail.id)"
                    color="rgb(248 71 6)"
                    class="white--text yatri_button"
                    v-if="notification_detail.status !== 'published'"
                >
                  <v-icon color="#bbbbc6" class="white--text mr-2">edit</v-icon>
                  Edit
                </v-btn>
            </v-flex>

            <v-card-text class="text-align">
              <v-flex xs12 md12 lg12 row style="display: flex;flex-wrap: wrap;">
                <v-flex xs12 sm4 md4 lg4>
                  <v-flex xs6 sm12 md12 lg12>
                    <strong>Status: </strong>
                  </v-flex>
                  <v-flex xs6 sm12 md12 lg12 style="font-weight: 500" >
                    <span style="color: #9e9e9e" disabled> {{ notification_detail.status }}</span>
                  </v-flex>
                </v-flex>


                <v-flex xs12 sm4 md4 lg4>
                  <v-flex xs12 sm12 md12 lg12>
                    <strong>Title: </strong>
                  </v-flex>
                  <v-flex style="font-weight: 500" xs12 md8 lg12>
                    <span style="color: #9e9e9e" disabled>{{ notification_detail.title }}</span>
                  </v-flex>
                </v-flex>

                <v-flex xs12 sm4 md4 lg4>
                  <v-flex xs12 sm12 md12 lg12>
                    <strong>Type: </strong>
                  </v-flex>
                  <v-flex style="font-weight: 500" xs12 md8 lg12>
                    <span style="color: #9e9e9e" disabled>{{ notification_detail.type }}</span>
                  </v-flex>
                </v-flex>
              </v-flex>


              <v-flex xs12 md12 lg12 row style="display: flex;flex-wrap: wrap;">
                <v-flex xs12 sm4 md4 lg4>
                  <v-flex xs12 md12 lg12>
                    <strong>Schedule At: </strong>
                  </v-flex>
                  <v-flex style="font-weight: 500" xs12 sm12 md12 lg12>
                    <span style="color: #9e9e9e" disabled> {{ notification_detail.schedule_at }}</span>
                  </v-flex>
                </v-flex>

                <v-flex xs12 sm4 md4 lg4>
                  <v-flex xs12 sm12 md12 lg12>
                    <strong>Url: </strong>
                  </v-flex>
                  <v-flex style="font-weight: 500" xs12 sm12 md12 lg12>
                    <span style="color: #9e9e9e" disabled>{{ notification_detail.link_url }}</span>
                  </v-flex>
                </v-flex>

                <v-flex xs12 sm4 md4 lg4 v-if="notification_detail.sent_to_topics != 'promotional_notifications'">
                  <v-flex xs12 md12 lg12>
                      <strong>Is_user_specific: </strong>
                    </v-flex>
                  <v-flex xs12 sm12 md12 lg12>
                    <v-checkbox style="padding: 0px !important;" disabled
                                v-model="notification_detail.is_user_specific"
                                label="User Specific"></v-checkbox>
                  </v-flex>
                </v-flex>

                <v-flex xs12 sm4 md4 lg4 v-if="notification_detail.sent_to_topics == 'promotional_notifications'">
                  <v-flex xs12 md12 lg12>
                    <strong>Event Name: </strong>
                  </v-flex>
                  <v-flex style="font-weight: 500" xs12 sm12 md12 lg12>
                    <span style="color: #9e9e9e" disabled> {{ notification_detail.event_name }}</span>
                  </v-flex>
                </v-flex>

              </v-flex>

              <v-flex xs12 md12 lg12 row style="display: flex;flex-wrap: wrap;">
                <v-flex xs12 sm4 md4 lg4>
                  <v-flex xs12 md4 lg12>
                    <strong>Body: </strong>
                  </v-flex>
                  <v-flex style="font-weight: 500" xs12 md8 lg12>
                    <span style="color: #9e9e9e" disabled> {{ notification_detail.body }}</span>
                  </v-flex>
                </v-flex>

                <v-flex xs12 sm4 md4 lg4>
                  <v-flex xs12 sm12 md12 lg12>
                    <strong>Topic: </strong>
                  </v-flex>
                  <v-flex style="font-weight: 500" xs12 sm12 md12 lg12>
                    <span style="color: #9e9e9e" disabled>{{ notification_detail.sent_to_topics }}</span>
                  </v-flex>
                </v-flex>

                <v-flex xs12 sm4 md4 lg4>
                  <v-flex xs12 md12 lg12>
                    <strong>City Name: </strong>
                  </v-flex>
                  <v-flex style="font-weight: 500" xs12 sm12 md12 lg12>
                    <span style="color: #9e9e9e" disabled> {{ notification_detail.city_name }}</span>
                  </v-flex>
                </v-flex>

              </v-flex>

              <v-flex xs12 md12 lg12 row style="display: flex;flex-wrap: wrap;">
                <v-flex xs12 sm4 md4 lg4>
                  <v-flex xs12 md4 lg12>
                    <strong>Image: </strong>
                  </v-flex>
                  <v-flex style="font-weight: 500;" xs12 md8 lg12>
                    <v-img style="width: 270px; height: 180px;" v-if="date > '2023-08-25'"
                           :src="notification_detail.image != null ? storage_image_url + notification_detail.image :
                        '/images/no_image.png'"
                    ></v-img>
                    <v-img style="width: 270px; height: 180px;" v-else
                           :src="notification_detail.image != null ? storage_path() + notification_detail.image :
                        '/images/no_image.png'"
                    ></v-img>
                  </v-flex>
                </v-flex>
              </v-flex>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <!-- Delete Resource dialog box -->
      <v-dialog
          v-model="status_model"
          scrollable
          :overlay="false"
          max-width="500px"
          transition="dialog-transition"
          persistent
      >
        <v-card>
          <v-form>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md12 lg12 v-if="dialog_message">
                  <h3>This Notification is Scheduled On {{ notification_detail.schedule_at }} ! Do you want to publish
                    now?</h3>
                </v-flex>
                <v-flex xs12 md12 lg12 v-else>
                  <h3>Are you sure you want to published this notification ?</h3>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" small @click="changeStaus()">OK</v-btn>
              <v-btn color="black" small flat type="reset" @click="status_model = false">Cancel</v-btn>

            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="delete_model"
          scrollable
          :overlay="false"
          max-width="500px"
          transition="dialog-transition"
          persistent
      >
        <v-card>
          <v-form>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md12 lg12>
                  <h3>Are you sure you want to delete the Notification?</h3>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small color="primary" @click="confirmDelete">Delete</v-btn>
              <v-btn
                  small
                  color="black"
                  flat
                  type="reset"
                  @click="delete_model = !delete_model"
              >Cancel
              </v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <v-snackbar
          :color="snack_bar.color"
          :top="snack_bar.top"
          :bottom="snack_bar.bottom"
          :left="snack_bar.left"
          :right="snack_bar.right"
          v-model="snack_bar.show"
      >
        {{ snack_bar.message }}
        <v-btn dark flat @click.native="snack_bar.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "Detail",

  data: () => {
    return {
      notification_detail: {},
      announcement_item: {},
      notification_id: "",
      delete_model: false,
      status_model: false,
      detail_loader: false,
      dialog_message: false,
      snack_bar: {
        show: false,
        color: "",
        message: "",
        top: true,
        right: true,
        bottom: false,
        left: false,
      },
      storage_image_url: "",
      date: "",
    };
  },

  methods: {
    backtonotification: function () {
      this.$router.push({name: "Notifications"});
    },
    getNotificationId: function (id) {
      this.notification_id = id;
      this.$router.push({
        name: "notificationUpdate",
        params: {notification_id: this.notification_id},
      });
    },

    getNotificationDetail: function () {
      this.detail_loader = true;

      axios
          .get(
              `${process.env.VUE_APP_API_URL}/api/v1/show-notification/` +
              this.$route.params.id,
              {headers: this.$headers}
          )
          .then((response) => {
            if (response.data.status == 1) {
              this.notification_detail = response.data.notification;
              this.cityList.forEach((item) => {
                if(item.id == this.notification_detail.city_id){
                  this.notification_detail.city_name = item.name;
                }
              });

              this.date = moment(this.notification_detail.created_at).format("YYYY-MM-DD");
              this.detail_loader = false;
            }
          })
          .catch((error) => {
            // console.log(error);
          });
    },
    deleteNotification: function (item) {
      this.announcement_item = item;
      this.delete_model = true;
    },
    confirmDelete: function () {
      this.detail_loader = true;
      // this.notificationLoading = true;
      axios
          .post(
              `${process.env.VUE_APP_API_URL}/api/v1/notification-delete`,
              {notification_id: this.announcement_item},
              {headers: this.$headers}
          )
          .then((response) => {
            if (response.data.status == 1) {
              this.detail_loader = false;
              // this.notificationLoading = false;
              this.$router.push({name: "Notifications"});
              this.delete_model = false;
              this.snack_bar.message = response.data.message;
              this.snack_bar.show = true;
            }
          })
          .catch((error) => {
          })
          .finally(() => {
          });
    },
    updateStaus: function (item, schedule_at) {
      this.announcement_item = item;
      // this.announcement_item = schedule_at;
      if (schedule_at != null) {
        this.dialog_message = true;
      } else {
        this.dialog_message = false;
      }

      this.status_model = true;
    },
    changeStaus: function (item) {
      this.detail_loader = true;
      axios
          .post(
              `${process.env.VUE_APP_API_URL}/api/v1/notification-status`,
              {notification_id: this.announcement_item},
              {headers: this.$headers}
          )
          .then((response) => {
            if (response.data.status == 1) {
              // this.notificationLoading = false;
              this.detail_loader = false;
              this.response_message = response.data.message;
              this.response_status = response.data.status;
              this.status_model = false;
              this.snack_bar.message = response.data.message;
              this.snack_bar.show = true;
              this.detail_loader = false;
              this.getNotificationDetail();
              // alert(response.data.message);
              // this.$router.push({ name: "Notifications" });

            }
          })
          .catch((error) => {
          })
          .finally(() => {
          });
    },
    getCityList(){
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/get-city-list`, {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.cityList = response.data.data;
              this.cityList.push({'id' : 0, 'name':"ALL"})
            }
          });
    }
  },
  mounted() {
    this.getCityList();
    this.getNotificationDetail();
    this.storage_image_url = process.env.VUE_APP_AZURE_STORAGE_URL + process.env.VUE_APP_AZURE_STORAGE_CONTAINER + "/";

  },
};
</script>
<style>
.text-align{
  text-align: left;
}

</style>


